import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SVG = styled.svg`
  width: 100%;
  height: auto;
  .clip,
  .polyline {
    fill: none;
  }

  .polygon {
    fill: #fff;
  }

  .polyline {
    stroke: #fff;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 4.5px;
  }
  .surface-water-resource {
    opacity: 0;
    transition: opacity 200ms linear;
    cursor: pointer;
  }
  .is-active {
    opacity: 1;
  }
  #aqaba {
    opacity: 0;
    cursor: unset;
  }
`;

const SVGLayer = ({active, setActiveProject}) => {
  function onClick(id, position) {
    setActiveProject(id, position);
  }
  return (
    <SVG id='surface' viewBox='0 0 1080 1540'>
      <defs>
        <clipPath id='clip-path' transform='translate(0 3.35)'>
          <rect className='clip' width='1080' height='1540' />
        </clipPath>
      </defs>

      <g
        style={{pointerEvents: 'bounding-box'}}
        className={`surface-water-resource`}
        id='aqaba'
        data-type='pool'
      >
        <polygon
          className='polygon'
          points='138 1493.25 163.1 1468.15 163.1 1443.15 163.1 1405.55 150.6 1392.95 125.5 1392.95 100.4 1418.05 87.8 1418.05 12.5 1493.25 12.5 1518.25 0 1530.85 0 1543.35 125.5 1543.35 138 1530.85 138 1510.95 138 1493.25'
        />
      </g>
      <g
        className={`surface-water-resource ${
          active === 'jordan-river' ? 'is-active' : 'is-hidden'
        }`}
        data-type='river'
        id='jordan-river'
        onClick={() => onClick('jordan-river')}
        style={{pointerEvents: 'bounding-box'}}
      >
        <polyline
          className='polyline'
          points='326.2 578.55 338.8 566.05 338.8 465.85 351.3 453.25 351.3 353.05 338.8 340.55 338.8 165.05 376.4 127.55 376.4 2.25'
        />
      </g>
      <g
        className={`surface-water-resource ${
          active === 'zarqa-river' ? 'is-active' : 'is-hidden'
        }`}
        data-type='river'
        id='zarqa-river'
        onClick={() => onClick('zarqa-river')}
        style={{pointerEvents: 'bounding-box'}}
      >
        <polyline
          className='polyline'
          points='351.3 440.75 376.4 415.65 426.6 415.65 439.1 428.25 501.9 428.25 514.4 415.65 527 415.65 539.5 403.15 577.1 403.15 602.2 428.25 602.2 465.85 614.8 478.35 614.8 503.35 639.9 528.45'
        />
      </g>
      <g
        className={`surface-water-resource ${
          active === 'deadsea' ? 'is-active' : 'is-hidden'
        }`}
        id='deadsea'
        data-type='pool'
        style={{pointerEvents: 'bounding-box'}}
        onClick={() => onClick('deadsea')}
      >
        <polygon
          className='polygon'
          points='301.1 653.75 338.8 616.15 338.8 591.15 313.7 566.05 301.1 566.05 263.5 603.65 263.5 616.15 250.9 628.65 250.9 753.95 263.5 766.55 276 766.55 301.1 741.45 301.1 766.55 313.7 779.05 313.7 804.15 326.2 791.55 326.2 741.45 301.1 716.35 301.1 653.75'
        />
        <polygon
          className='polygon'
          points='288.6 779.05 288.6 766.55 263.5 791.55 250.9 804.15 250.9 829.15 263.5 841.65 263.5 879.25 276 866.75 276 854.25 301.1 829.15 301.1 816.65 276 791.55 288.6 779.05'
        />
      </g>

      <g
        onClick={() => onClick('taberias')}
        style={{pointerEvents: 'bounding-box'}}
        className={`surface-water-resource ${
          active === 'taberias' ? 'is-active' : 'is-hidden'
        }`}
        data-type='pool'
        id='taberias'
      >
        <polygon
          className='polygon'
          points='326.2 77.35 363.9 39.85 376.4 39.85 401.5 64.85 401.5 127.55 376.4 152.55 351.3 152.55 351.3 127.55 326.2 102.45 326.2 77.35'
        />
      </g>

      <g
        onClick={() => onClick('yarmouk-river')}
        style={{pointerEvents: 'bounding-box'}}
        className={`surface-water-resource ${
          active === 'yarmouk-river' ? 'is-active' : 'is-hidden'
        }`}
        data-type='river'
        id='yarmouk-river'
      >
        <polyline
          className='polyline'
          points='338.8 252.85 401.5 190.15 476.8 190.15 476.8 202.65 501.9 227.75 501.9 227.75'
        />
      </g>
    </SVG>
  );
};

SVGLayer.propTypes = {
  active: PropTypes.string,
  setActiveProject: PropTypes.func,
};

export default SVGLayer;
